export enum ActivePageEnum {
    ANALYSIS_PLAYER,
    ANALYSIS_SQUAD,
    ANALYSIS_SQUAD_PERIOD,
    ANALYSIS_SQUAD_PLAYER_COMPARISON
}